import {TableContainer,Table,TableHead,TableRow,TableCell,TableBody,Grid, Button, Box} from "@deere/fuel-react"
import { useUserInfo } from '../providers/userProvider'
import { SCBM_USER_TYPE } from '../utils/surveyLiterals'
import { useTranslation } from "react-i18next";

export default function FuelTable({headers,data,resetForm,sx, isCampaignClosed}){
  const { t } = useTranslation();
  const userInfo = useUserInfo();
  let tableCellStyle;
  if(sx){
    tableCellStyle = sx.tableCellStyle;
  }
  return (
    <>
        <TableContainer>
          <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                  <TableRow>
                      {headers.map((header) => (
                        <TableCell sx={tableCellStyle}>{header}</TableCell>
                      ))}
                  </TableRow>
              </TableHead>
              <TableBody>
                  {data.map((row) => (row))}
              </TableBody>
          </Table>
        </TableContainer>
        <br/>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end">
            <Button disabled={isCampaignClosed} variant="primary" sx={{ mr: 2 }}  onClick={e => resetForm()} >{t('btn_add_another_resp')}</Button>
          </Box>
        </Grid>
      </>
    );
  };